// React Imports
import React, { useEffect, useRef, useState } from "react";

// Internationalization Import
import i18n from "i18next";
import { Button, Tooltip } from "@fluentui/react-components";
import useWindowSize from "../../helpers/useWindowSize";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import {
  ArrowUploadRegular,
  LockClosedRegular,
  PeopleTeamRegular,
} from "@fluentui/react-icons";
import { IUserProduct } from "../../Models/IUserProduct";
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { baseUrl } from "../../helpers/constants";

// Internal Imports

// Props
interface IProductDocumentsCommandbarProps {
  userProduct?: IUserProduct | undefined;
  onDocumentUploaded(): void;
}

// Function
function ProductDocumentsCommandbar(props: IProductDocumentsCommandbarProps) {
  const windowSize = useWindowSize();
  const isMobile = windowSize.width < 800;

  const inputFile = useRef<any>(null);

  const onSelectedFile = (event: any) => {
    uploadFile(event.target.files);
  };

  const uploadFile = (files: any[]) => {
    if (files != undefined && props.userProduct?.userProduktGuid) {
      for (let i = 0; i < files.length; i++) {
        var data = new FormData();
        data.append("file", files[i]);
        fetchWrapper
          .sendFilesWithAuth(
            `${baseUrl}/api/Documents/UploadFile?id=${props.userProduct.userProduktGuid}&name=${files[i].name}`,
            data
          )
          .then((result) => {
            props.onDocumentUploaded();
          });
      }
    }
  };

  return (
    <div className="lueb-InnerContentBlockPadding2px">
      <input
        title="uploadFile"
        disabled={props.userProduct?.userProduktGuid == undefined}
        type="file"
        id="file"
        multiple
        accept=".pdf"
        ref={inputFile}
        className="lueb-hide"
        onChange={onSelectedFile}
      />

      <StackShim
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: isMobile ? 15 : 0 }}
      >
        <Button
          appearance="subtle"
          disabled={!props.userProduct?.userProduktGuid}
          icon={<ArrowUploadRegular />}
          onClick={() => {
            if (inputFile && inputFile.current) {
              inputFile.current.click();
            }
          }}
        >
          {i18n.t<string>("uploadFiles")}
        </Button>
      </StackShim>
    </div>
  );
}

// Export Function
export default ProductDocumentsCommandbar;
